import { httpResource } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

import { logError } from '../../helper/log.helper';
import { TrendImportMonitorModel, isTrendImportMonitorModel } from './trend-import-monitor.model';

export const TREND_IMPORT_MONITOR_URL = '/api/v1/sys/monitor/trend-imports';

/** Provided by `TrendImportMonitorComponent`, so the data is dropped when leaving the page. */
@Injectable()
export class TrendImportMonitorService {
  /** First (newest) day of the monitor in `YYYY-MM-DD`, `undefined` = today */
  readonly start = signal<string | undefined>(undefined);

  readonly monitorResource = httpResource<TrendImportMonitorModel>(
    () => {
      const start = this.start();
      const params: Record<string, string> = start ? { start } : {};
      return { url: TREND_IMPORT_MONITOR_URL, params };
    },
    {
      parse: (value) => {
        if (isTrendImportMonitorModel(value)) {
          return value;
        }
        const err = new Error('Received invalid result from trend import monitor request');
        logError(err, { extra: { response: value } });
        throw err;
      },
    },
  );
}
